var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SettingsNavigation'),_c('div',{staticClass:"max-w-screen-xl mx-auto sm:grid sm:grid-cols-2 sm:gap-x-6 px-6"},[_c('AboutCard'),_c('LogoCard')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }